<span class="close-modal-container">
  <em class="icon-close_medium close-modal" (click)="modal.dismiss()"></em>
</span>
<div class="header-info">
  <h3 class="modal-title">To download the file:</h3>
</div>
<div class="modal-body">
  Click <b>Open in New Tab</b> to view it. Then use your browser's <b>Print</b> or <b>Save as PDF</b> option to download
  it.
</div>
<div class="buttons-container">
  <button class="close-button" (click)="modal.dismiss()">
    Cancel
  </button>
  <button class="open-in-new-tab" (click)="onClickOpenInNewTab()">
    Open in New Tab
  </button>
</div>
